import { AssessmentReportFillTemplate } from "app/features/reporting/templates/AssessmentReportFillTemplate";
import { useResidentContext } from "app/features/residents/provider/ResidentProvider";

interface Props {
  formId?: number;
}
export function MedicalNotesReportScreen({ formId }: Props) {
  const { resident } = useResidentContext();

  const backPath = resident?.id
    ? `/residents/${resident.id}/medical-notes`
    : undefined;

  return <AssessmentReportFillTemplate formId={formId} backPath={backPath} />;
}
